import { render, staticRenderFns } from "./PrimaryFooterMenu.vue?vue&type=template&id=9347c19c&"
import script from "./PrimaryFooterMenu.vue?vue&type=script&lang=js&"
export * from "./PrimaryFooterMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports